import { useMemo } from "react";

const LAB_TASKS = {
  lab1: [
    "Create folder cyberlab",
    "Check folder using ls",
    "Check working directory using pwd",
    "Create a new directory structure - new Directory Project1",
    "Create sub folders in Project1 documents, src, models , constants, data ",
  ],
  lab2: [
    "Create file file21.txt",
    "Give read/write/execute Permission to the file using chmod 777",
    "Check Permissions using ls -l",
    "Verify you are able to read the file using cat command",
    "Change Permissions so that no one can read the file including you",
    "Verify you are NOT able to read the file using cat command",
  ],
  lab3: ["Displays and configures network interfaces using ifconfig", 
         "Verify IP address Subnet Mask and MAC address",
         "Tests connectivity between devices using nmap localhost",
          "Check port scanning & Network discovery",
         "Scan hosts and services on a network using ping google.com",
         "Verify host availability and configuration",
         ],
  lab4: [
    "Create a new empty File file22,txt",
    "Read File Permissions",
    "Change File Permissions such that everyone is only able to read the file",
    "Check File Permissions",
    "Use vi editor  (vi file22.txt) or nano file22.txt to write into the file ",
    "Verify writing into the file is not allowed",
  ],
  lab5: [
    "Create a new empty File file23.txt",
    "Read File Permissions using ls -l ",
    "Change File Permissions such that everyone is able to write in the file",
    "Check File Permissions",
    "Use vi editor  (vi file22.txt) or nano file22.txt to write into the file ",
    "Verify writing into the file is  allowed",
  ],
  lab6: [
    "Create a new directory named Sticky so that file rename or delete is not allowed to others",
    "Give Read Write Execute Permission to all (chmod 777 Sticky)",
    "Use Sticky bit (chmod +t Sticky)  to create directory Permissions",
    "Check the Directory Permissions",
    "Verify existance of sticky bit t instead of x",
    "Verify /tmp directory for sticky bit (ls -ld /tmp)",
    " Discuss Why /tmp directory has a sticky bit ",
  ],
  lab7: [
      "Create a new hidden file (touch .hiddenFile)", 
      "Check hidden files using ls -al",
      "Create a hidden directory named .hiddenDirectory",
      "Change permissions of a hidden file uwing chmod 777 giving all permissions to hidden file",
      "Copy a hidden file, move a hidden file, delete a hidden file",
      "List ONLY hidden Files using (ls -d .*)",
      "Discuss why linux systems use hidden files",
      ],
  lab8:[
  "Create a new hidden file touch .HiddenFile",
  "Find all hidden files in the current directory (find . -type f -name \".*\")",
  "Find all hidden files and directories (find . -name \".*\")",
  "List only hidden files in current directory (ls -A)",
  "Search hidden files in a specific directory (find /path/to/directory -name \".*\")",
  "Use ls to quickly view hidden files recursively (ls -laR)"
],
  lab9: [
  "Find all hidden files in /home, /etc, and /var (find /home /etc /var -name \".*\" 2>/dev/null)",
  "Identify hidden directories in /tmp (find /tmp -type d -name \".*\")",
  "List hidden .bash* configuration files (find /home -type f -name \".bash*\")",
  "Search for passwords in hidden files (grep -r \"password\" .)",
  "Find API keys in configuration files (grep -r \"api_key\" .)",
  "Detect SSH private keys accidentally stored (grep -r \"PRIVATE KEY\" ~/.ssh 2>/dev/null)"
],
  lab10: [
  "Identify recently modified hidden files (find /home -type f -name \".*\" -mtime -7)",
  "Find hidden files owned by root in user directories (find /home -type f -name \".*\" -user root)",
  "Detect hidden cron-related files (find /etc/cron* -type f 2>/dev/null)",
  "Find hidden files containing password (find . -type f -name \".*\" -exec grep -l \"password\" {} \\;)",
  "Identify world-writable hidden files (find . -type f -name \".*\" -perm /o=w)",
  "Detect sensitive config files with weak permissions (find /etc -type f -name \".*conf\" -exec ls -l {} \\;)",
  "Locate hidden scripts in /tmp (find /tmp -type f -name \".*sh\")",
  "Search hidden files containing shell commands (grep -r \"bash\" /tmp 2>/dev/null)",
  "Detect execution traces in hidden logs (find /var/log -type f -name \".*log\")"
],
  lab11: [
    "Create user account",
    "Verify user account",
    "Modify user settings",
    "Change password",
    "Delete user",
  ],
  lab12: [
    "Check password policy",
    "Verify shadow file",
    "Configure expiration",
  ],
  lab13: [
    "Create user",
    "Assign group",
    "Set permissions",
  ],
  lab14: [
    "Create group",
    "Add user",
    "Verify membership",
  ],
  lab15: [
    "Identify privileged accounts",
    "Grant sudo access",
    "Verify sudo",
  ],
};

export function useLabTasks(labId) {
  return useMemo(() => {
    const key = String(labId || "lab1").toLowerCase();
    return LAB_TASKS[key] || [];
  }, [labId]);
}







